document.addEventListener('DOMContentLoaded', () => {
  let eventForm = document.getElementById('grillesContest');
  let submitBtn = document.querySelector('#grillesContest input[type=submit]');

  if(eventForm) {
    eventForm.addEventListener('submit', function(e) {
      e.preventDefault();
      document.querySelector('#addInfo p a').style.pointerEvents = 'none';
      document.getElementById('addInfo').style.opacity = '0';
      eventForm.style.opacity = '0.2';
      submitBtn.setAttribute('disabled', '');
      submitBtn.classList.remove('c-btn--primary');
  
      let fd = new FormData(this);
  
      let fName = fd.get('first-name').trim();
      let lName = fd.get('last-name').trim();
  
      let username = `${fName} ${lName}`.toLowerCase().replace(/\s/gi, '_');
  
      let email = fd.get('email');
      let phone = fd.get('phone');
      
      let files = fd.getAll('file');
  
      const folderUrl = 'https://script.google.com/macros/s/AKfycbxp4rRGxYY0PMkfEnZSQUF68UkPKwJFJFPvaOFp8uBeDVAEj3SwsCNEMiyaI9HrFbXNhg/exec';
      const root = "1P-HnyIiwxDXkQlsEhPLtIhu9MoYrZVCW" // <--- Please set the id of the Drive folder
  
  
      // PS: The file upload web app, spreadsheet web app, and the google drive should be all from the same google account
  
      let submitForm = fetch(folderUrl, {method: "POST", body: JSON.stringify({driveId: root, username: username})})
      .then(res => {

        let to = 'carleyd@kulgrilles.com';
        let cc = 'ishand@kulgrilles.com';
        let subject = 'Ugly Grilles Contest New Entry';
        let htmlBody = `
        <div>
          <h1>Ugly Grilles Contest New Entry</h1>
          <br/>
          <p>First Name: ${fName}</p>
          <p>Last Name: ${lName}</p>
          <p>Email: <a href="mailto:${email}">${email}</a></p>
          <p>Phone Number: ${phone}</p>
          <p>Folder Name: ${username}</p>
        </div>
        `;

        let mailUrl = 'https://script.google.com/macros/s/AKfycbxtGs09MgImWMu1EHz_HQIXT9jmzeV478SEKhSxHGe5OywN3g0KP2mXYeDCJvnApRtE/exec';
        let mailPayload = {
          to: to,
          cc: cc,
          subject: subject,
          body: htmlBody
        };

        fetch(mailUrl, {method: "POST", body: JSON.stringify(mailPayload)});
        
        return res.json();
      })
      .then(a => {
        let r = Promise.all([...files].map((file, i) => {
          return new Promise(r => {
            let fr = new FileReader();
        
            fr.readAsArrayBuffer(file);
            fr.onload = e => {
              const data = e.target.result;
        
              const uploadUrl = "https://script.google.com/macros/s/AKfycbwoTW6uKFItEtj7EtuzcmaZipZGHtffgxQu_njXwYsa8xa8U31ijLBaqO8aLNBGVpJh-w/exec" // <--- Please set the URL of Google Web App
        
              let fileJSON = {
                'fileData': [...new Int8Array(data)],
                'mimeType': file.type,
                'fileName': file.name
              };
        
              let uploadPayload = {
                'username': username,
                'file': fileJSON,
                'driveId': root,
              };
        
              fetch(uploadUrl, {method: "POST", body: JSON.stringify(uploadPayload)})
              .then(res => r(res.json()));
            };
          });
        }))
        .then(data => {

          eventForm.reset();
          submitBtn.removeAttribute('disabled');
          submitBtn.classList.add('c-btn--primary');
          document.getElementById('addInfo').style.opacity = '1';
          document.querySelector('#addInfo p a').style.pointerEvents = 'auto';
          document.querySelector('#submit_success p').style.display = "block";
          setTimeout(() => {
            eventForm.style.opacity = '1';
            document.querySelector('#submit_success p').style.display = "none";
          },4000);

          if(a.existing === false) {
            let sheetId = '1VFJ2MlJ5zI1heGYn6aq5fMT3854flMUXhr4oqs6C1Vc';
            let sheet = 'Sheet1';
            let sheetUrl = 'https://script.google.com/macros/s/AKfycbwBbH1PRAg59y05gpvR03ZeB-wmT2g0sYZtMsuBW_lzeWkFssKNupCKvIGnUnQfeLSa3A/exec';
  
            let sheetData = [fName, lName, email, phone, username, data[0].folderUrl]
            let sheetPayload = {
              sheetId: sheetId,
              sheetName: sheet,
              sheetData: [sheetData]
            };
  
            fetch(sheetUrl, {method: "POST", body: JSON.stringify(sheetPayload)})
            .then(res => res.json())
            .then(ef => console.log('sent'));

          };
        });
      })
      .catch(err => console.log(err));
    });
  };
});